import React, {useState, Fragment} from "react";

import classes from "./Layout.module.css"
import Toolbar from "../../../components/Navigation/ToolBar/Toolbar";
import SideDrawer from "../../../components/Navigation/NavigationItems/SideDrawer/SideDrawer";
import Footer from "../../../components/UI/Footer/Footer";

const Layout = props => {
    const [drawerState, setDrawerState] = useState(false);

    const toggleDrawer = () => {
        setDrawerState(prevState => !prevState);
    };

    return (
        <Fragment>
            <div className={classes.Box}>
                <div>
                    <Toolbar toggleDrawer={toggleDrawer}/>
                    <SideDrawer toggleDrawer={toggleDrawer}
                                drawerState={drawerState}/>
                </div>
                <main className={classes.Content}>
                    {props.children}
                </main>
            </div>
            <Footer/>
        </Fragment>
    );
};

export default Layout;
